import { createAction } from 'redux-actions';
import { PapiGallection } from '@wix/da-papi-types';
import { GallerySettings } from '../../types/gallerySettings';

export const loadSettings = createAction(
  'GALLERY_SETTINGS.LOAD_SETTINGS',
  () => ({})
);

export const loadSettingsSuccess = createAction(
  'GALLERY_SETTINGS.LOAD_SETTINGS_SUCCESS',
  (settings: GallerySettings) => ({ settings })
);

export const loadSettingsFailure = createAction(
  'GALLERY_SETTINGS.LOAD_SETTINGS_FAILURE',
  (error: string) => ({ error })
);

export const loadGalleries = createAction(
  'GALLERY_SETTINGS.LOAD_GALLERIES',
  () => ({})
);

export const loadGalleriesSuccess = createAction(
  'GALLERY_SETTINGS.LOAD_GALLERIES_SUCCESS',
  (galleries: PapiGallection[]) => ({ galleries })
);

export const loadGalleriesFailure = createAction(
  'GALLERY_SETTINGS.LOAD_GALLERIES_FAILURE',
  (error: string) => ({ error })
);

export const saveSettings = createAction(
  'GALLERY_SETTINGS.SAVE_SETTINGS',
  (settings: GallerySettings) => settings
);

export const saveSettingsSuccess = createAction(
  'GALLERY_SETTINGS.SAVE_SETTINGS_SUCCESS',
  (settings: GallerySettings) => ({ settings })
);

export const saveSettingsFailure = createAction(
  'GALLERY_SETTINGS.SAVE_SETTINGS_FAILURE',
  (error: string) => ({ error })
);

export const resetState = createAction(
  'GALLERY_SETTINGS.RESET_STATE',
  () => ({})
);
